import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../common/SectionTitle';
import CollegeCard from '../common/CollegeCard';

const FeaturedColleges: React.FC = () => {
  const colleges = [
    {
      id: 'sourabh',
      name: 'Sourabh College of Veterinary Science',
      location: 'Hindaun City, Rajasthan',
      imageUrl: 'https://images.pexels.com/photos/1472462/pexels-photo-1472462.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      description: 'A premier institute offering quality education in veterinary science with state-of-the-art facilities and experienced faculty.'
    },
    {
      id: 'rps',
      name: 'RPS College of Veterinary Science',
      location: 'Mahendergarh, Haryana',
      imageUrl: 'https://images.pexels.com/photos/3786157/pexels-photo-3786157.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      description: 'Renowned for its excellent academic programs and cutting-edge research facilities in animal health and welfare.'
    },
    {
      id: 'abhilashi',
      name: 'Abhilashi Veterinary College',
      location: 'Mandi, Himachal Pradesh',
      imageUrl: 'https://images.pexels.com/photos/267885/pexels-photo-267885.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      description: 'Known for its holistic approach to veterinary education with focus on practical training and modern teaching methodologies.'
    }
  ];

  return (
    <section className="section">
      <div className="container-custom">
        <SectionTitle 
          title="Featured Colleges" 
          subtitle="We work with top veterinary colleges across India to provide quality education and training."
        />
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {colleges.map(college => (
            <CollegeCard 
              key={college.id}
              id={college.id}
              name={college.name}
              location={college.location}
              imageUrl={college.imageUrl}
              description={college.description}
            />
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Link to="/colleges" className="btn btn-primary">
            View All Colleges
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedColleges;